import React from 'react';
import "./Contact.css";
import MSG from "../../assets/images/msg-icon.png";
import mail_icon from "../../assets/images/mail-icon2.png";
import phone_icon from "../../assets/images/phone-icon2.png";
// import location_icon from "../../assets/images/location-icon2.png";

const Contact = () => {
    const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "dace78f4-df68-480e-8362-f4688c966365");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div className='contact'>
        <div className='contact-col'>
            <h3>Send us a Message <img src={MSG} alt="Message icon"/></h3>
            <p>Feel free to reach out through contact form or find our contact information below.
                Your feedback, questions, and suggestions are important to us as we strive to provide exceptional
                service to our community</p>
                <ul>
                    <li><img src={mail_icon} alt="Email icon"/>info@learn-technology.in</li>
                    <li><img src={phone_icon} alt="Phone icon"/>+91-8950181700</li>
                    {/*<li><img src={location_icon} alt="Location icon"/>B8-505, Adjacent to White Land, Kherki Daula Road, Sector 76<br/>Gurugram, Haryana</li>*/}
                </ul>
        </div>

        <div className='contact-col'>
            <form onSubmit={onSubmit}>
                <label>Your Name</label>
                    <input type='text' name='name' placeholder='Enter Your Name' required/>
                <label>Phone Number</label>
                    <input type='tel' name='phone' placeholder='Enter Your Mobile Number' required/>
                <label>Write Your Message Here</label>
                    <textarea name='message' rows='6' placeholder='Enter Your Message' required></textarea>
                <button type='submit' className='btn dark-btn'>Submit now</button>
            </form>
            <span>{result}</span>
        </div>

    </div>
  )
}

export default Contact
